(function () {
    'use strict';

    /**
     * @ngdoc factory
     * @name manageFlights.factory:ManageFlightsRequestFactory
     *
     * @description
     *
     */
    angular
        .module('greatCircleDistance')
        .factory('GreatCircleDistanceFactory', GreatCircleDistanceFactory);
    
    function GreatCircleDistanceFactory() {

        function SearchDistanceRequest() {
            this.origin = null;
            this.destination = null;
            this.pageSize = null;
            this.startPosition = null;
        }
        
        function SaveDistanceRequest() {
        	this.gridCircleId = null;
            this.origin = null;
            this.destination = null;
            this.distance = null;
        }


        var searchDistanceRQ = function (searchParams) {
            var searchDistance = new SearchDistanceRequest();
            searchDistance.origin = angular.isUndefined(searchParams.origin.value) || searchParams.origin.value === null ? null : searchParams.origin.value.airPortCode;
            searchDistance.destination = angular.isUndefined(searchParams.destination.value) || searchParams.destination.value === null ? null : searchParams.destination.value.airPortCode;
            searchDistance.pageSize = searchParams.pageSize;
            searchDistance.startPosition = searchParams.startPosition;
            return searchDistance;
        };
        
        var saveDistanceRQ = function (requestParams) {
            var saveDistance = new SaveDistanceRequest();
            saveDistance.gridCircleId = angular.isUndefined(requestParams.gridCircleId) ? null : requestParams.gridCircleId; 
            saveDistance.origin = angular.isUndefined(requestParams.origin) || requestParams.origin === null ? null : requestParams.origin.airPortCode;
            saveDistance.destination = angular.isUndefined(requestParams.destination) || requestParams.destination.airPortCode === null ? null : requestParams.destination.airPortCode;
            saveDistance.distance = requestParams.distance;
            return saveDistance;
        };

        return{
        	searchDistanceRQ : searchDistanceRQ,
        	saveDistanceRQ  : saveDistanceRQ ,
        }
    }
})();